import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ReportedLogin from './pages/ReportedLogin';
import ReportedDashboard from './pages/ReportedDashboard';

const ReportedPersonModule = () => {
  return (
    <Routes>
      <Route path="/" element={<ReportedLogin />} />
      <Route path="login" element={<ReportedLogin />} />
      <Route path="dashboard" element={<ReportedDashboard />} />
    </Routes>
  );
};

export default ReportedPersonModule;